/**
 * A track the server reports as gone (Subsonic error 70, "data not found").
 * Pure, so `tests/playback-guards.test.mts` can use it without a bundler.
 */

/** Raised when the server reports the track itself as gone (Subsonic error 70). */
export class MediaNotFoundError extends Error {
    readonly mediaId: string;

    constructor(mediaId: string, message?: string) {
        super(message || `Track not found on the server: ${mediaId}`);
        this.name = 'MediaNotFoundError';
        this.mediaId = mediaId;
    }
}

export const isMediaNotFoundError = (error: unknown): error is MediaNotFoundError =>
    error instanceof MediaNotFoundError ||
    (error instanceof Error && error.name === 'MediaNotFoundError');

/**
 * Stream-URL query retries: a track the server says is gone stays gone, so it
 * is not asked for again; anything else keeps the usual three attempts.
 */
export const shouldRetryStreamUrl = (failureCount: number, error: unknown): boolean =>
    !isMediaNotFoundError(error) && failureCount < 3;
